var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.667 8.0013C14.667 11.6806 11.6803 14.668 8.00033 14.668C4.31366 14.668 1.33366 11.6806 1.33366 8.0013C1.33366 4.32064 4.31366 1.33464 8.00032 1.33464C11.6803 1.33464 14.667 4.32064 14.667 8.0013ZM8.58703 10.528C8.58703 10.8473 8.32036 11.1147 8.00036 11.1147C7.68036 11.1147 7.42036 10.8473 7.42036 10.528L7.42036 7.58133C7.42036 7.26066 7.68036 7.00133 8.00036 7.00133C8.32036 7.00133 8.58703 7.26066 8.58703 7.58133L8.58703 10.528ZM7.99362 4.88052C8.32028 4.88052 8.58029 5.14719 8.58029 5.46719C8.58029 5.78719 8.32029 6.04719 8.00028 6.04719C7.67362 6.04719 7.41362 5.78719 7.41362 5.46719C7.41362 5.14719 7.67362 4.88052 7.99362 4.88052Z",
    fill: "#EB4E2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoRed);
export default __webpack_public_path__ + "static/media/info-red.839d32f15d8091e7460f779a2e0e38f6.svg";
export { ForwardRef as ReactComponent };